import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack } from "@mui/material";
import { ArrowLeft } from "mdi-material-ui";
import { useTranslation } from "react-i18next";
export const CardActions = ({ backButton, children, }) => {
    // @ts-ignore
    const { t } = useTranslation("common");
    return (_jsxs(Stack, { direction: "row-reverse", spacing: 1, sx: { mt: -2, mb: 1, flexWrap: "wrap-reverse" }, children: [children, backButton && (_jsx(Button, { color: "inherit", startIcon: _jsx(ArrowLeft, {}), sx: { "&&": { mr: "auto" } }, ...backButton, children: t("back") }))] }));
};
//# sourceMappingURL=CardActions.js.map